import React from 'react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useOpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getOneClickCardOrCry } from '@tectonics/prs/one-click-card';
import { SelectedCardBrandProvider } from '@tectonics/look-and-feel/commons/selected-card-brand';
import { formatOneClickCardInfoLabel } from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/commons/format-one-click-card-label';
import { CardIcon } from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/card-form/fields/card-icon';
import { FieldCardSecurityCode, FieldCardSecurityCodeAlert } from '@tectonics/components/form/fields/card-security-code';

export function OneClickForm(): ReactNode {
  const { t } = useTranslation('volcanes');
  const incomingPayment = useOpenedIncomingPayment();
  const oneClickCard = getOneClickCardOrCry(incomingPayment);

  return (
    <SelectedCardBrandProvider cardBrand={oneClickCard.brand}>
      <div className="flex flex-col gap-8">
        <div className="flex-1">
          <div className="flex flex-col gap-2">
            <label>{t('fieldCardNumber')}</label>

            <div className="flex h-full items-center gap-3">
              <CardIcon brand={oneClickCard.brand} />
              <span>{formatOneClickCardInfoLabel(oneClickCard)}</span>
            </div>
          </div>
        </div>

        <FieldCardSecurityCode />
        <FieldCardSecurityCodeAlert />
      </div>
    </SelectedCardBrandProvider>
  );
}
